import React from 'react'
import assetLoader from '@utils/internalImageLoader'
import Image from 'next/image'
import styles2 from './fastagModal.module.scss'
import styles from './fastagWidget.module.scss'
import { ARROW_ICON, CHECK_FASTAG_PROVIDER_ALT, CHECK_FASTAG_PROVIDER_IMG, FIND_FASTAG_PROIVDER_TEXT, ICONS } from './constants'

const FindFastagProvider = ({ setShowFastagProviderImg, showFastagProviderImg }) => (
    <div className={styles2.findFastagProvider}>
                <div
                  className={styles2.fastagProviderHeading}
                  onClick={() => setShowFastagProviderImg(!showFastagProviderImg)}>
                  <span>{FIND_FASTAG_PROIVDER_TEXT}</span>
                  <span>
                    <Image
                      src={ICONS.arrowDown}
                      alt={ARROW_ICON}
                      width={20}
                      height={20}
                      className={`${showFastagProviderImg ? styles.toggelSvg : ''}`}
                    />
                  </span>
                </div>
                {showFastagProviderImg && (
                  <div className={styles2.showProviderImg}>
                    <Image
                      src={`${assetLoader()}${CHECK_FASTAG_PROVIDER_IMG}`}
                      alt={CHECK_FASTAG_PROVIDER_ALT}
                      width={10}
                      height={10}
                      className={styles2.fastagProviderImg}
                    />
                  </div>
                )}
              </div>
  )

export default FindFastagProvider
